import { assertUnreachable } from '../../shared/assertUnreachable';
import { isAudioLineItem } from './AudioLineItem';
import { isTranscriptLineItem } from './CertifiedTranscriptLineItem';
import { UnexpectedLineItemType } from './error';
import { LineItemType } from './LineItemType';
import { isRealTimeLineItem } from './RealTimeLineItem';
export const LINE_ITEM_FRIENDLY_NAME = {
    [LineItemType.Audio]: 'Audio Recording',
    [LineItemType.CertifiedTranscript]: 'Transcript',
    [LineItemType.RealTime]: 'RealTime Order',
};
export function assertIsAudioOrRealTimeLineItem(lineItem, message) {
    if (!isAudioOrRealTimeLineItem(lineItem)) {
        throw typeof message === 'object'
            ? message
            : new UnexpectedLineItemType(message !== null && message !== void 0 ? message : `Expected ${LineItemType.Audio} or ${LineItemType.RealTime} line item, but received ${lineItem.type} line item`);
    }
}
export function assertIsAudioOrTranscriptLineItem(lineItem, message) {
    if (!isAudioOrTranscriptLineItem(lineItem)) {
        throw typeof message === 'object'
            ? message
            : new UnexpectedLineItemType(message !== null && message !== void 0 ? message : `Expected ${LineItemType.Audio} or ${LineItemType.CertifiedTranscript} line item, but received ${lineItem.type} line item`);
    }
}
export function getEstimateIfAvailable(lineItem) {
    return matchLineItemType(lineItem, {
        audio: audioLineItem => audioLineItem.estimate,
        realtime: () => undefined,
        transcript: transcriptLineItem => transcriptLineItem.estimate,
    });
}
export function isAudioOrRealTimeLineItem(lineItem) {
    return isAudioLineItem(lineItem) || isRealTimeLineItem(lineItem);
}
export function isAudioOrTranscriptLineItem(lineItem) {
    return isAudioLineItem(lineItem) || isTranscriptLineItem(lineItem);
}
export function getCaseInfo(lineItem) {
    if (isAudioOrTranscriptLineItem(lineItem)) {
        return {
            caseNumber: lineItem.caseNumber,
            caseTitle: lineItem.caseTitle,
        };
    }
    return undefined;
}
export function matchLineItemType(lineItem, { audio, realtime, transcript }) {
    switch (lineItem.type) {
        case LineItemType.Audio:
            return audio(lineItem);
        case LineItemType.CertifiedTranscript:
            return transcript(lineItem);
        case LineItemType.RealTime:
            return realtime(lineItem);
        default:
            assertUnreachable(lineItem.type);
    }
}
